import React from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowRight, Clock } from "lucide-react";
import { useLang } from "../context/LanguageContext";

const spanClasses = {
  lg: "md:col-span-8 md:row-span-2",
  md: "md:col-span-6",
  sm: "md:col-span-4",
};

export const ActivityCard = ({ activity, variant = "sm" }) => {
  const { lang, t } = useLang();
  const cls = spanClasses[variant] || spanClasses.sm;
  const isLarge = variant === "lg";

  return (
    <motion.div
      initial={{ opacity: 0, y: 24 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-80px" }}
      transition={{ duration: 0.6 }}
      className={`group relative overflow-hidden rounded-2xl border border-black/5 bg-white shadow-[0_1px_2px_rgba(11,25,44,0.04)] transition-all duration-500 hover:-translate-y-1 hover:shadow-[0_20px_50px_-20px_rgba(11,25,44,0.25)] ${cls}`}
      data-testid={`activity-card-${activity.id}`}
    >
      <div className={`relative overflow-hidden ${isLarge ? "aspect-[16/11]" : "aspect-[4/3]"}`}>
        <img
          src={activity.image}
          alt={activity.title[lang]}
          className="h-full w-full object-cover img-zoom"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-[#0B192C]/60 via-transparent to-transparent opacity-70" />
        <div className="absolute left-5 top-5 inline-flex items-center gap-2 rounded-full bg-white/80 backdrop-blur px-3 py-1.5 text-[11px] font-medium text-[#0B192C]">
          <Clock size={12} strokeWidth={2} />
          {activity.duration[lang]}
        </div>
      </div>
      <div className="p-6 md:p-7">
        <h3 className={`h-display font-medium ${isLarge ? "text-2xl md:text-3xl" : "text-xl"} text-[#0B192C]`}>
          {activity.title[lang]}
        </h3>
        <p className="mt-3 text-[#475569] text-[15px] leading-relaxed font-light">
          {activity.description[lang]}
        </p>
        <div className="mt-5 flex items-center justify-between">
          <Link
            to={`/booking?activity=${activity.id}`}
            className="inline-flex items-center gap-1.5 text-[13px] font-semibold text-[#0B192C] group/btn"
            data-testid={`activity-book-${activity.id}`}
          >
            {t.activities.book}
            <ArrowRight size={14} className="transition-transform group-hover/btn:translate-x-1" />
          </Link>
          <span className="text-[11px] uppercase tracking-[0.2em] text-[#94A3B8]">Lofoten</span>
        </div>
      </div>
    </motion.div>
  );
};

export default ActivityCard;
